import { findAndVerifySpreadsheetEmailApi } from '../../api/enrichmentApi';
import { parseApiError } from '../../helper/spreadsheetView';
// Load combined-email execution only when the user requests this action.
export function createCombinedEmailRunner() {
  let runnerPromise;
  return async (input) => {
    if (!runnerPromise) {
      runnerPromise = import('./combinedEmailOperation')
        .then((operation) => operation.createCombinedEmailRunner(findAndVerifySpreadsheetEmailApi))
        .catch((error) => { runnerPromise = null; throw error; });
    }
    return (await runnerPromise)(input);
  };
}

export async function runCombinedEmailForCompanies(options) {
  const operation = await import('./combinedEmailOperation');
  return operation.runCombinedEmailForCompanies({...options, parseApiError});
}
